import { Alert, Box, Container, Grid2 as Grid, Skeleton } from "@mui/material";
import { handleRetrieveBlogs } from "../../../../redux/public-slices/blog.slice";
import TablePagination from "../../../../components/common/TablePagination";
import SectionSkeleton from "../../../../components/ui/SectionSkeleton";
import ContentCard from "../../../../components/common/Content";
import { FILE_PATH_URI } from "../../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect, useMemo } from "react";
import Images from "../../Home/temp-data/Images";
import { Fragment, lazy, Suspense } from "react";
import { useParams } from "react-router-dom";
import Aside from "./Aside";

const TopBannerB = lazy(() =>
  import("../../../../components/common/TopBannerB")
);

function BlogCategory() {
  const dispatch = useDispatch();
  const { categoryId } = useParams();
  const [data, setData] = useState([]);
  const { loadings } = useSelector((state) => state.otherSlice);

  // Handle get all blogs
  const handleRetrieveAll = async (filters) => {
    const response = await dispatch(
      handleRetrieveBlogs({
        categoryId: categoryId || null,
        currentPage: filters?.currentPage || null,
      })
    ).unwrap();
    setData(response);
  };

  useMemo(() => {
    handleRetrieveAll();
    // eslint-disable-next-line
  }, [categoryId]);

  useEffect(() => {
    handleRetrieveAll();
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerB
          bannerImg={Images?.forumImg4}
          headline={data?.category?.name}
        />
      </Suspense>

      <Box sx={{ py: { xs: 5, lg: 10 }, bgcolor: "#f1f1f1" }}>
        <Container maxWidth={false}>
          <Grid container spacing={4}>
            <Grid size={{ xs: 12, laptop: 8 }}>
              <Box
                sx={{
                  ml: "auto",
                  maxWidth: "1000px",
                  height: "fit-content",
                  position: "sticky",
                  top: 20,

                  overflowY: "auto",
                }}
              >
                <Grid container spacing={2}>
                  {loadings?.retrieveAll ? (
                    new Array(4).fill().map((_, i) => (
                      <Grid key={i} size={{ xs: 12, md: 6 }}>
                        <Skeleton
                          sx={{
                            width: "100%",
                            transform: "none",
                            aspectRatio: "1/0.5",
                          }}
                        />
                      </Grid>
                    ))
                  ) : data?.records?.length === 0 ? (
                    <Grid size={12}>
                      <Alert
                        sx={{
                          fontSize: "20px",
                          fontWeight: "500",
                          alignItems: "center",
                          fontFamily: "Poppins",
                          ".MuiAlert-message": { p: "0" },
                          ".MuiAlert-icon": { fontSize: "28px" },
                        }}
                        color="error"
                        severity="error"
                      >
                        No Records Found!
                      </Alert>
                    </Grid>
                  ) : (
                    data?.records?.map((element, i) => (
                      <Grid key={i} size={{ xs: 12, md: 6 }}>
                        <ContentCard
                          id={element._id}
                          title={element.title}
                          image={FILE_PATH_URI + (element.banner?.path || element.banner?.source || "")}
                          date={element.createdAt}
                          description={element.description}
                          type="blog"
                        />
                      </Grid>
                    ))
                  )}
                </Grid>

                <TablePagination
                  pagination={data?.pagination}
                  length={data?.records?.length}
                  loading={loadings?.retrieveAll}
                  cb={handleRetrieveAll}
                />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, laptop: 4 }}>
              <Box
                sx={{
                  py: 8,
                  px: 3,
                  gap: 10,
                  height: "100%",
                  display: "flex",
                  borderRadius: 2,
                  bgcolor: "#EBF5F5",
                  flexDirection: "column",
                  boxShadow: "0 0 10px 0 #0000000a",
                }}
              >
                <Aside />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Fragment>
  );
}

export default BlogCategory;
